/**
 * Created by Ethan on 2017/9/6.
 */

const ja_JP = {

    APP_BRAND: "工业及仓储管理",

    COMMON_BUTTON_OK: "确定",
    COMMON_BUTTON_ADD: "添加",
    COMMON_BUTTON_CREATE: "创建",
    COMMON_BUTTON_UPDATE: "更新",
    COMMON_BUTTON_SAVE: "保存",
    COMMON_BUTTON_SAVE_DRAFT: "保存草稿",
    COMMON_BUTTON_MODIFY: "修改",
    COMMON_BUTTON_EDIT: "编辑",
    COMMON_BUTTON_REMOVE: "移除",
    COMMON_BUTTON_DELETE: "删除",
    COMMON_BUTTON_SUBMIT: "提交",
    COMMON_BUTTON_CANCEL: "取消",
    COMMON_BUTTON_SEARCH: "查询",
    COMMON_BUTTON_SAVEANDCLOSE: "保存并关闭",
    COMMON_BUTTON_SEARCH_CLEAR: "清空查询",
    COMMON_BUTTON_SEARCH_ADVANCE: "高级查询",
    COMMON_BUTTON_DRAFT: "保存草稿",
    COMMON_BUTTON_EXPORT: "导出",
    COMMON_BUTTON_SELECT: "选择",
    COMMON_BUTTON_BACK: "返回",
    COMMON_BUTTON_UPLOAD: "上传",
    COMMON_BUTTON_SCAN: "扫描",
    COMMON_BUTTON_STOP: "停止",
    COMMON_BUTTON_REFRESH: "刷新",
    COMMON_BUTTON_DETAIL: "详细",
    COMMON_BUTTON_CLOSE: "关闭",
    COMMON_BUTTON_COPY: "复制",
    COMMON_BUTTON_NEW: "新建",
    COMMON_BUTTON_COMPARE: "比较",

    COMMON_FIELD_REMARKS: "备注",
    COMMON_FIELD_REMARKS_PLACEHOLDER: "请输入备注",
    COMMON_FIELD_ENABLED: "有效",
    COMMON_FIELD_DISABLED: "无效",
    COMMON_FIELD_ACTION: "操作",
    COMMON_FIELD_HAVE: "有",
    COMMON_FIELD_NOTHING: "无",
    COMMON_FIELD_PAGINATION_TOTAL: "共 {sum} 条",
    COMMON_FIELD_HEIGHT: "高",
    COMMON_FIELD_WIDTH: "宽",
    COMMON_FIELD_DEEP: "深",
    COMMON_FIELD_FLOOR: "层",
    COMMON_FIELD_NUMBER: "序号",
    COMMON_FIELD_UNIT_M: "米",
    COMMON_FIELD_UNIT_M2: "平方米",
    COMMON_FIELD_UNIT_T_M2: "吨/平方米",
    COMMON_PLACEHOLDER_FUZZY_QUERY: "模糊查询",
    COMMON_PLACEHOLDER_SELECT_DATE: "选择日期",

    // COMMON_MSG_EXIST_DATA: "您已经加入此方案。",
    COMMON_MSG_UPLOAD_CONTINUE: "上传中，请稍后。。。",
    COMMON_MSG_CREATE_SUCCESS: "创建已完成",
    COMMON_MSG_UPDATE_SUCCESS: "更新已完成",
    COMMON_MSG_DELETE_SUCCESS: "删除已完成",
    COMMON_MSG_DELETE_TITLE: "删除确认",
    COMMON_MSG_UPDATE_TITLE: "修改确认",
    COMMON_MSG_DELETE_CONFIRM: "删除后无法恢复，请确认是否删除？",
    COMMON_MSG_UPDATE_CONFIRM: "是否修改主联系人，请确认？",
    COMMON_MSG_REQUIRED: "不能为空",
    COMMON_MSG_BOTH_CHOOSE: "两项必填一项",
    COMMON_MSG_UNEXPECTED_EXCEPTION: "未处理异常，请联系管理员",
    COMMON_MSG_CREATE_FAVORITES: "收藏成功",

    // 账户管理-角色
    ACCOUNT_ROLE_FIELD_NAME: "角色",

    ACCOUNT_USER_ROUTE_LOGIN_PASSWORD: "密码登录",
    ACCOUNT_USER_ROUTE_REGISTER: "用户注册",
    ACCOUNT_USER_ROUTE_LIST: "用户一览",
    ACCOUNT_USER_ROUTE_PROFILE: "用户基本信息",
    ACCOUNT_USER_ROUTE_PASSWORD: "用户密码",
    ACCOUNT_USER_ROUTE_PASSWORD_MODIFY: "修改密码",
    ACCOUNT_USER_ROUTE_PASSWORD_FORGOT: "忘记密码",

    ACCOUNT_USER_TITLE_CREATE: "创建新用户",
    ACCOUNT_USER_TITLE_UPDATE: "更新用户",
    ACCOUNT_USER_TITLE_DELETE: "删除用户",
    ACCOUNT_USER_FIELD_UID: "用户ID",
    ACCOUNT_USER_FIELD_UID_PLACEHOLDER: "用户ID/邮箱/手机号",
    ACCOUNT_USER_FIELD_PASSWORD_OLD: "旧密码",
    ACCOUNT_USER_FIELD_PASSWORD: "密码",
    ACCOUNT_USER_FIELD_PASSWORD_CONFIRM: "确认密码",
    ACCOUNT_USER_FIELD_EMAIL: "邮箱",
    ACCOUNT_USER_FIELD_EMAIL_VERIFY_CODE: "邮箱验证码",
    ACCOUNT_USER_FIELD_MOBILE: "手机号",
    ACCOUNT_USER_FIELD_FIRST_NAME: "名",
    ACCOUNT_USER_FIELD_LAST_NAME: "姓",
    ACCOUNT_USER_FIELD_FULL_NAME: "姓名",
    ACCOUNT_USER_FIELD_ROLE: "角色",
    ACCOUNT_USER_FIELD_ENABLE: "有效性",
    ACCOUNT_USER_BUTTON_SUBMIT: "登录",
    ACCOUNT_USER_BUTTON_REGISTER: "注册新用户",
    ACCOUNT_USER_BUTTON_EMAIL_VERIFY_CODE: "发送验证码",
    ACCOUNT_USER_MSG_UID_REQUIRED: "用户ID是不能为空",
    ACCOUNT_USER_MSG_PASSWORD_REQUIRED: "密码不能为空",
    ACCOUNT_USER_MSG_PASSWORD_WRONG: "密码错误",
    ACCOUNT_USER_MSG_OLD_PASSWORD_REQUIRED: "旧密码不能为空",
    ACCOUNT_USER_MSG_OLD_PASSWORD_WRONG: "旧密码错误",
    ACCOUNT_USER_MSG_PASSWORD_LENGTH_REQUIRED: "密码长度不能少于{value}个字符",
    ACCOUNT_USER_MSG_PASSWORD_STRENGTH_REQUIRED: "密码必须包含字符，数字，特殊符号的组合",
    ACCOUNT_USER_MSG_PASSWORD_CONFIRM_REQUIRED: "密码确认不能为空",
    ACCOUNT_USER_MSG_PASSWORD_CONFIRM_EQUAL_REQUIRED: "两次密码不想等",
    ACCOUNT_USER_MSG_MOBILE_REQUIRED: "手机号不能为空",
    ACCOUNT_USER_MSG_MOBILE_FORMAT_WRONG: "手机号格式不正确",
    ACCOUNT_USER_MSG_EMAIL_REQUIRED: "邮箱不能为空",
    ACCOUNT_USER_MSG_EMAIL_FORMAT_WRONG: "邮箱格式不正确",
    ACCOUNT_USER_MSG_EMAIL_CODE_REQUIRED: "邮箱验证码不能为空",
    ACCOUNT_USER_MSG_EMAIL_CODE_SEND_SUCCESS: "邮箱验证码发送成功",
    ACCOUNT_USER_MSG_EMAIL_CODE_NOT_FOUND: "邮箱验证码不正确",
    ACCOUNT_USER_MSG_LAST_NAME_REQUIRED: "姓不能为空",
    ACCOUNT_USER_MSG_FIRST_NAME_REQUIRED: "名不能为空",
    ACCOUNT_USER_MSG_ROLE_REQUIRED: "角色不能为空",
    ACCOUNT_USER_MSG_AUTH_TOKEN_EXPIRED: "登录令牌过期",
    ACCOUNT_USER_MSG_AUTH_TOKEN_NON_PRINCIPAL: "登录令牌不存在",
    ACCOUNT_USER_MSG_PASSWORD_RESET_SUCCESS: "密码修改成功",
    ACCOUNT_USER_MSG_CREATE_SUCCESS: "用户创建成功",
    ACCOUNT_USER_MSG_UPDATE_SUCCESS: "用户更新成功",
    ACCOUNT_USER_MSG_DELETE_SUCCESS: "用户删除成功",
    ACCOUNT_USER_MSG_DELETE_CONFIRM: "用户删除确认吗？",
    ACCOUNT_USER_MSG_NOT_FOUND: "该用户不存在",

    ACCOUNT_APP_MSG_ACCESS_FORBIDDEN: "该应用禁止访问",
    ACCOUNT_APP_MSG_ACCESS_NOT_FOUND: "该应用未正确注册",
    ACCOUNT_APP_MSG_ACCESS_DISABLED: "该应用未激活",

    // 组织管理-组织
    ORG_ROUTER_MANAGEMENT: "组织管理",
    ORG_ORGANIZATION_ROUTE_LIST: "组织一览",
    ORG_ORGANIZATION_TITLE_CREATE: "创建新组织",
    ORG_ORGANIZATION_TITLE_UPDATE: "更新组织",
    ORG_ORGANIZATION_TITLE_DELETE: "删除组织",
    ORG_ORGANIZATION_FIELD_PARENT: "上级组织",
    ORG_ORGANIZATION_FIELD_CODE: "编号",
    ORG_ORGANIZATION_FIELD_NAME: "名称",
    ORG_ORGANIZATION_FIELD_TYPE: "类型",
    ORG_ORGANIZATION_FIELD_TYPE_GROUP: "总部",
    ORG_ORGANIZATION_FIELD_TYPE_SUB_CENTER: "分部",
    ORG_ORGANIZATION_FIELD_TYPE_PROPERTY_COMPANY: "物业公司",
    ORG_ORGANIZATION_FIELD_TYPE_COMMUNITY: "管理小区",
    ORG_ORGANIZATION_FIELD_TYPE_MANAGE_SECTION: "管养段",
    ORG_ORGANIZATION_FIELD_TYPE_RESIDENT: "居民",
    ORG_ORGANIZATION_FIELD_TYPE_REPAIRMAN: "维修员",
    ORG_ORGANIZATION_FIELD_TYPE_COMPANY: "第三方维修单位",
    ORG_ORGANIZATION_FIELD_TYPE_REPAIR_UNIT: "维保公司",
    ORG_ORGANIZATION_FIELD_TYPE_EMPLOYEE: "工作人员",
    ORG_ORGANIZATION_FIELD_CONTACTS: "联系人",
    ORG_ORGANIZATION_FIELD_TELEPHONE: "联系电话",
    ORG_ORGANIZATION_FIELD_ADDRESS: "联系地址",
    ORG_ORGANIZATION_MSG_CODE_REQUIRED: "组织编号不能为空",
    ORG_ORGANIZATION_MSG_NAME_REQUIRED: "组织名不能为空",
    ORG_ORGANIZATION_MSG_TYPE_REQUIRED: "组织类型不能为空",
    ORG_ORGANIZATION_MSG_CREATE_SUCCESS: "组织创建成功",
    ORG_ORGANIZATION_MSG_UPDATE_SUCCESS: "组织更新成功",
    ORG_ORGANIZATION_MSG_DELETE_SUCCESS: "组织删除成功",
    ORG_ORGANIZATION_MSG_DELETE_CONFIRM: "组织删除确认吗？",
    ORG_ORGANIZATION_MSG_PARENT_DEAD_CYCLE: "不可设置父组织为自己",
    // 组织管理-员工
    ORG_EMPLOYEE_ROUTE_LIST: "系统用户",
    ORG_EMPLOYEE_TITLE_CREATE: "员工创建",
    ORG_EMPLOYEE_TITLE_UPDATE: "员工更新",
    ORG_EMPLOYEE_TITLE_DELETE: "员工删除",
    ORG_EMPLOYEE_FIELD_CODE: "工号",
    ORG_EMPLOYEE_FIELD_FULL_NAME: "姓名",
    ORG_EMPLOYEE_FIELD_MOBILE: "手机号",
    ORG_EMPLOYEE_FIELD_ORGANIZATION: "组织",
    ORG_EMPLOYEE_FIELD_ORGANIZATION_PARENT: "上级组织",
    ORG_EMPLOYEE_FIELD_LAST_NAME: "姓",
    ORG_EMPLOYEE_FIELD_FIRST_NAME: "名",
    ORG_EMPLOYEE_FIELD_EMAIL: "邮箱",
    ORG_EMPLOYEE_FIELD_EMAIL_VERIFY_CODE: "Verify Code",
    ORG_EMPLOYEE_BUTTON_SEND_VERIFY_EMAIL_CODE: "Send verify code",
    ORG_EMPLOYEE_BUTTON_REGISTER: "Register",
    ORG_EMPLOYEE_MSG_ORGANIZATION_ID_REQUIRED: "员工所属组织是必填项。",
    ORG_EMPLOYEE_MSG_LAST_NAME_REQUIRED: "员工姓氏是必填项",
    ORG_EMPLOYEE_MSG_FIRST_NAME_REQUIRED: "员工名字是必填项",
    ORG_EMPLOYEE_MSG_CODE_REQUIRED: "员工号是必填项。",
    ORG_EMPLOYEE_MSG_EMAIL_REQUIRED: "员工邮箱是必填项。",
    ORG_EMPLOYEE_MSG_EMAIL_DUPLICATE: "员工邮箱重复。",
    ORG_EMPLOYEE_MSG_EMAIL_FORMAT_WRONG: "员工邮箱格式错误。",
    ORG_EMPLOYEE_MSG_MOBILE_REQUIRED: "员工手机号是必填项。",
    ORG_EMPLOYEE_MSG_REGISTER_SUCCESS: "注册成功",
    ORG_EMPLOYEE_MSG_CREATE_SUCCESS: "员工创建成功",
    ORG_EMPLOYEE_MSG_UPDATE_SUCCESS: "员工更新成功",
    ORG_EMPLOYEE_MSG_DELETE_SUCCESS: "员工删除成功",
    ORG_EMPLOYEE_MSG_DELETE_CONFIRM: "员工删除确认吗？",

    // 文件管理
    FTP_FILE_ROUTE_LIST: "文件一览",
    FTP_FILE_FIELD_NAME: "文件名",
    FTP_FILE_FIELD_PATH: "文件路径",
    FTP_FILE_FIELD_LAST_MODIFIED: "最后修改日期",
    FTP_MSG_UPLOAD_SUCCEED: "上传成功",
    FTP_MSG_UPLOAD_FAILED: "上传失败",

    //房源筛选显示的标签
    WMS_ZONE_ROUTE_ACCEPT_RENT: "接受短租",
    WMS_ZONE_ROUTE_PRIVATE_HOUSE: "独门独院",
    WMS_ZONE_ROUTE_PLENTY_POWER: "电量充足",
    WMS_ZONE_ROUTE_EXPRESS_DISTRIBUTION: "快递分拨",
    WMS_ZONE_ROUTE_RETURNABLE_COLD_STORAGE: "可改冷库",
    WMS_ZONE_ROUTE_COMPULSORY_REGISTRATION: "强制注册",
    WMS_ZONE_ROUTE_LIMITED_TIME_SPECIAL: "限时特价",
    WMS_ZONE_ROUTE_NEW_ON_THE_7TH: "7日上新",
    WMS_ZONE_ROUTE_LATEST_TRANSACTION: "最新成交",

    // 房源管理
    WMS_ZONE_ROUTE_MANAGEMENT: "房源管理",
    WMS_ZONE_ROUTE_FILTER: "房源筛选",
    WMS_ZONE_ROUTE_LIST: "房源一览",
    WMS_ZONE_ROUTE_CREATE: "房源创建",
    WMS_ZONE_ROUTE_IMPORT: "房源导入",
    WMS_ZONE_ROUTE_FAVORITES: "我的收藏",
    WMS_ZONE_TITLE_CREATE_ZONE: "创建项目信息",
    WMS_ZONE_TITLE_UPDATE_ZONE: "更新项目信息",
    WMS_ZONE_TITLE_DETAILS_VERSION: "详情版",
    WMS_ZONE_TITLE_SIMPLE_VERSION: "简易版",
    WMS_ZONE_TITLE_DELETE: "项目信息删除",
    WMS_ZONE_TITLE_CREATE_BUILDING: "创建物业信息",
    WMS_ZONE_TITLE_UPDATE_BUILDING: "更新物业信息",
    WMS_ZONE_TITLE_BASIC_INFO: "基础信息",
    WMS_ZONE_TITLE_SPECIFICATION: "规格信息",
    WMS_ZONE_TITLE_BUILDINGS: "物业管理",
    WMS_ZONE_TITLE_CONTACTS: "联系人",
    WMS_ZONE_TITLE_BUSINESS: "商务信息及租约",
    WMS_ZONE_TITLE_VACANT_AREA_FLOOR: "按楼层分",
    WMS_ZONE_TITLE_VACANT_AREA_SPECIFIC: "按物业规格分",
    WMS_ZONE_TITLE_ZONE_PICTURE_UPLOAD: "房源照片上传",
    WMS_ZONE_FIELD_ZONE_DRAWINGS_AND_PHOTO_UPLOAD: "图纸及证照上传",
    WMS_ZONE_BUTTON_CREATE_ZONE: "创建项目",
    WMS_ZONE_BUTTON_CREATE_BUILDING: "创建物业",
    WMS_ZONE_BUTTON_CREATE_LESSOR_COMPANY: "新建出租方公司",
    WMS_ZONE_BUTTON_CREATE_LESSOR_CONTACT: "新建出租方联系人",
    WMS_ZONE_BUTTON_LOCATION_PICK_UP: "拾点",
    WMS_ZONE_BUTTON_LOCATION_RAGE: "描边",
    WMS_ZONE_FIELD_FUZZY_PLACEHOLDER: "地址/编号/项目名",
    WMS_ZONE_FIELD_HOLP_LIVE_DATE: "希望入驻时间",
    WMS_ZONE_FIELD_NUMBER: "房源编号",
    WMS_ZONE_FIELD_NUMBER_PLACEHOLDER: "房源编号自动生成",
    WMS_ZONE_FIELD_PROVINCE_CITY_DISTRICT: "省市行政区",
    WMS_ZONE_FIELD_PROVINCE: "省份",
    WMS_ZONE_FIELD_CITY: "城市",
    WMS_ZONE_FIELD_DISTRICT: "行政区",
    WMS_ZONE_FIELD_TOWN: "镇",
    WMS_ZONE_FIELD_NAME: "项目名称",
    WMS_ZONE_FIELD_ADDRESS: "项目地址",
    WMS_ZONE_FIELD_LOCATION: "坐标",
    WMS_ZONE_FIELD_LONGITUDE: "经度",
    WMS_ZONE_FIELD_LATITUDE: "纬度",
    WMS_ZONE_FIELD_LOCATION_RANG: "坐标范围",
    WMS_ZONE_FIELD_LAND_AREA: "土地面积",
    WMS_ZONE_FIELD_PROPERTY_IN_LAND: "土地所有权",
    WMS_ZONE_FIELD_LAND_USE: "土地用途",
    WMS_ZONE_FIELD_STATE_OWNED_LAND: "国有用地",
    WMS_ZONE_FIELD_COLLECTIVE_LAND: "集体用地",
    WMS_ZONE_FIELD_PRODUCTION_LAND: "军产用地",
    WMS_ZONE_FIELD_INDUSTRIAL_LAND: "工业用地",
    WMS_ZONE_FIELD_WAREHOUSE_LAND: "仓储用地",
    WMS_ZONE_FIELD_LAND_AREA_UNKNOWN: "不详",
    WMS_ZONE_FIELD_PROPERTY_LEVEL: "物业等级",
    WMS_ZONE_FIELD_CLASS_A_WAREHOUSE: "A类仓库",
    WMS_ZONE_FIELD_CLASS_B_WAREHOUSE: "B类库房",
    WMS_ZONE_FIELD_CLASS_C_WORKSHOP: "C类厂房",
    WMS_ZONE_FIELD_BUILDING_AREA: "建筑面积",
    WMS_ZONE_FIELD_VACANT_AREA: "空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_CURRENT: "当前空置",
    WMS_ZONE_FIELD_VACANT_AREA_CONSTRUCTION: "在建待租",
    WMS_ZONE_FIELD_VACANT_AREA_DUE_TO: "租约到期",
    WMS_ZONE_FIELD_VACANT_AREA_TO_RENT: "可租时间",
    WMS_ZONE_FIELD_VACANT_WAREHOUSE_AREA: "仓库面积",
    WMS_ZONE_FIELD_VACANT_OFFICE_AREA: "独立办公楼面积",
    WMS_ZONE_FIELD_VACANT_SUPPORTING_AREA: "配套楼面积",
    WMS_ZONE_FIELD_VACANT_SUPPORTING_FACILITY: "配套楼功能",
    WMS_ZONE_FIELD_HOPE_IN_TIME: "希望入驻时间",
    WMS_ZONE_FIELD_LEASE_AREA: "可租赁面积",
    WMS_ZONE_FIELD_VACANT_RATE: "空置率",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_1: "一层空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_2: "二层级以上空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_SINGLE: "单层仓库空置面积",
    WMS_ZONE_FIELD_VACANT_AREA_FLOOR_DOUBLE: "多层仓库空置面积",
    WMS_ZONE_FIELD_STATUS: "状态",
    WMS_ZONE_FIELD_STATUS_COMPLETED: "已建成",
    WMS_ZONE_FIELD_RADIUS_FIVE: "附近五公里",
    WMS_ZONE_FIELD_RADIUS_TEN: "附近十公里",
    WMS_ZONE_FIELD_RADIUS_FIFTEEN: "附近十五公里",
    WMS_ZONE_FIELD_RADIUS_TWENTY: "附近二十公里",
    WMS_ZONE_FIELD_STATUS_IN_PROGRESS: "在建",
    WMS_ZONE_FIELD_COMPLETION_DATE: "竣工年份",
    WMS_ZONE_FIELD_TAG: "标签",
    WMS_ZONE_FIELD_LOCATION_LOAD_AREA: "土地面积",
    WMS_ZONE_FIELD_LOCATION_BUILDING_AREA: "建筑面积",
    WMS_ZONE_FIELD_COMPLETION_DATE_UNKNOWN: "不详",
    WMS_ZONE_FIELD_BUILDING_SUM: "栋数",
    WMS_ZONE_FIELD_RENT_RANGE: "租金报价区间",
    WMS_ZONE_FIELD_RENT_MIN: "租金最低报价",
    WMS_ZONE_FIELD_RENT_MIN_PLACEHOLDER: "最低",
    WMS_ZONE_FIELD_RENT_MAX: "租金最高报价",
    WMS_ZONE_FIELD_RENT_MAX_PLACEHOLDER: "最低",
    WMS_ZONE_FIELD_RENT_UNIT: "租金报价单位",
    WMS_ZONE_FIELD_RENT_UNIT_DAY: "元/平方米/天",
    WMS_ZONE_FIELD_RENT_UNIT_MONTH: "元/平方米/月",
    WMS_ZONE_FIELD_RENT_UNIT_YEAR: "元/平方米/年",
    WMS_ZONE_FIELD_RENT_TAX_TYPE: "租金报价税类型",
    WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_INCLUDE: "含税",
    WMS_ZONE_FIELD_RENT_TAX_TYPE_TAX_FREE: "不含税",
    WMS_ZONE_FIELD_RENT_TAX_RATE: "租金报价税点",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE: "租金报价物业类型",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_INCLUDE: "含物业",
    WMS_ZONE_FIELD_RENT_PROPERTY_TYPE_FREE: "不含物业",
    WMS_ZONE_FIELD_RENT_INCREASE: "租金增幅",
    WMS_ZONE_FIELD_RENT_FREE: "免租期",
    WMS_ZONE_FIELD_RENT_FREE_CONDITION: "年免",
    WMS_ZONE_FIELD_RENT_NEGOTIABLE: "(面议)",
    WMS_ZONE_FIELD_RENT_FREE_PERIOD: "个月",
    WMS_ZONE_FIELD_RENT_FREE_BUILDING: "栋",
    WMS_ZONE_FIELD_RENT_LAND_DEED: "张土地证",
    WMS_ZONE_FIELD_PROPERTY_FEE: "物业费",
    WMS_ZONE_FIELD_PROPERTY_FEE_UNIT: "物业费单位",
    WMS_ZONE_FIELD_RENTAL_AREA_MIN: "最小出租单元面积",
    WMS_ZONE_FIELD_RENTAL_AREA_UNIT_MIN: "起租面积",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT: "租金物业拆分",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE: "租金物业调整",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_ADJUST: "调整",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_NO_ADJUST: "不调整",
    WMS_ZONE_FIELD_RENT_PROPERTY_SPLIT_TYPE_UNKNOWN: "不详",
    WMS_ZONE_FIELD_LESSOR_COMPANY: "出租方公司",
    WMS_ZONE_FIELD_LESSOR_CONTACT: "出租方联系人",
    WMS_ZONE_FIELD_ZONE_PHOTO:"房源照片",
    WMS_ZONE_FIELD_ZONE_PHOTO_TAG:"房源照片标签",
    WMS_ZONE_FIELD_ZONE_PHOTO_ACTIVE_FLAG:"是否激活",

    WMS_ZONE_FIELD_ZONE_DRAWINGS_AND_PHOTO: "图纸及证照",
    WMS_ZONE_FIELD_ZONE_FILE_TAG: "标签",
    WMS_ZONE_FIELD_ZONE_FILE_ACTIVE_FLAG: "是否激活",
    WMS_ZONE_MSG_SAVE_ZONE_WARNING: "请保存项目",
    WMS_ZONE_MSG_BUILDINGS_CREATE_WARNING_CONTENT: "物业创建之前，请先保存项目",

    //房源照片标签
    WMS_ZONE_ROUTE_PHOTO_AERIAL_VIEW: "鸟瞰图",
    WMS_ZONE_ROUTE_PHOTO_RENDERING_VIEW: "效果图",
    WMS_ZONE_ROUTE_PHOTO_EXTERNAL_FACADE_VIEW: "外部正面图",
    WMS_ZONE_ROUTE_PHOTO_EXTERNAL_PROFILE_VIEW: "外部侧面图",
    WMS_ZONE_ROUTE_PHOTO_INTERNAL_LENGTH_AXIS_VIEW: "内部长轴图",
    WMS_ZONE_ROUTE_PHOTO_INTERNAL_SHORT_AXIS_VIEW: "内部短轴图",
    WMS_ZONE_ROUTE_PHOTO_INTERIOR_DIAGONAL_VIEW: "内部对角图",
    WMS_ZONE_ROUTE_PHOTO_FIRE_PROTECTION_SYSTEM: "消防系统",
    WMS_ZONE_ROUTE_PHOTO_LIFT_PLATFORM: "升降平台",
    WMS_ZONE_ROUTE_PHOTO_FLOW_FIELD: "周转场地",
    WMS_ZONE_ROUTE_PHOTO_SUPPORTING_FACILITIES: "配套设施",
    //房源文件标签
    WMS_ZONE_FILE_TAG_LAND_CERTIFICATE: "土地证",
    WMS_ZONE_FILE_TAG_FIRE_CHECK_REPORT: "消防验收意见书",
    WMS_ZONE_FILE_TAG_PROJECT_PLAN_CERTIFICATE: "工程规划许可证",
    WMS_ZONE_FILE_TAG_PROJECT_WORK_CERTIFICATE: "工程施工许可证",
    WMS_ZONE_FILE_TAG_PROJECT_END_REPORT: "竣工验收备案",
    WMS_ZONE_FILE_TAG_HOUSE_CERTIFICATE: "房产证",
    WMS_ZONE_FILE_TAG_ZONE_TOTAL_VIEW: "项目总平面图",
    WMS_ZONE_FILE_TAG_ZONE_HORIZONTAL_VERTICAL_VIEW: "房屋平立剖",
    WMS_ZONE_FILE_TAG_CAD_DRAWINGS: "CAD图纸",
    WMS_ZONE_FILE_TAG_PROJECT_INTRODUCTION: "项目介绍",
    // 房源物业管理
    WMS_BUILDING_FIELD_NUMBER: "物业编号",
    WMS_BUILDING_FIELD_ZONE: "所属项目",
    WMS_BUILDING_FIELD_TYPE: "建筑类型",
    WMS_BUILDING_FIELD_TYPE_SINGLE: "单层库",
    WMS_BUILDING_FIELD_TYPE_MULTI_RAMP: "多层坡道库",
    WMS_BUILDING_FIELD_TYPE_MULTI_ELEVATOR: "多层电梯库",
    WMS_BUILDING_FIELD_TYPE_FLAT: "平库",
    WMS_BUILDING_FIELD_TYPE_WORKSHOP: "厂房",
    WMS_BUILDING_FIELD_FLOOR_SUM: "层数",
    WMS_BUILDING_FIELD_FLOOR_HEIGHT: "{sum} 层净高",
    WMS_BUILDING_FIELD_FLOOR_LOAD: "{sum} 层荷载",
    WMS_BUILDING_FIELD_FIRE_FACILITIES: "消防设施",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_ESFR: "ESFR快速喷淋",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_BUBBLE: "消防水泡",
    WMS_BUILDING_FIELD_FIRE_FACILITIES_HYDRANT: "消防栓",
    WMS_BUILDING_FIELD_FIRE_RATING: "消防等级",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C2: "丙-2类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C: "丙类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_C1: "丙-1类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_D: "丁类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_B: "乙类",
    WMS_BUILDING_FIELD_FIRE_RATING_CLASS_A: "甲类",
    WMS_BUILDING_FIELD_PLATFORM_FLAG: "月台有无",
    WMS_BUILDING_FIELD_PLATFORM_TYPE: "月台类型",
    WMS_BUILDING_FIELD_PLATFORM_TYPE_INSIDE: "内置式",
    WMS_BUILDING_FIELD_PLATFORM_TYPE_OUTSIDE: "外置式",
    WMS_BUILDING_FIELD_PLATFORM_HEIGHT: "月台高度",
    WMS_BUILDING_FIELD_PLATFORM_WIDTH: "月台宽度",
    WMS_BUILDING_FIELD_TRAIN_WORKING: "行车",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY: "配套设施",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_DORMITORY: "宿舍",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_CANTEEN: "食堂",
    WMS_BUILDING_FIELD_SUPPORTING_FACILITY_FLAG: "配套设施有无",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS: "落税要求",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_MANDATORY: "强制落税",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_NO_MANDATORY: "无强制要求",
    WMS_BUILDING_FIELD_TAX_REQUIREMENTS_UNKNOWN: "不详",
    WMS_BUILDING_FIELD_BUSINESS_TYPE: "仓库属性",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_GENERAL: "普货仓",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_BONDED: "保税库",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_COLD: "冷库",
    WMS_BUILDING_FIELD_BUSINESS_TYPE_DANGEROUS: "危险品库",
    WMS_BUILDING_FIELD_LICENSE: "证照",
    WMS_BUILDING_FIELD_LICENSE_LAND: "土地证",
    WMS_BUILDING_FIELD_LICENSE_PROJECT: "工程规划许可证",
    WMS_BUILDING_FIELD_LICENSE_BUILDER: "施工许可证",
    WMS_BUILDING_FIELD_LICENSE_HOUSE: "房产证",
    WMS_BUILDING_FIELD_UNLOADING_TYPE: "卸货方式",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_SINGLE: "单面",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_DOUBLE: "双面",
    WMS_BUILDING_FIELD_UNLOADING_TYPE_MULTI: "多面",
    WMS_BUILDING_FIELD_POWER_DISTRIBUTION: "配电",
    WMS_BUILDING_FIELD_BUILDING_AREA: "建筑面积",
    WMS_BUILDING_FIELD_VACANT_AREA: "空置面积",
    WMS_BUILDING_FIELD_VACANCY_RATE: "空置率",
    WMS_BUILDING_FIELD_TURNOVER_AREA: "周转场地",
    WMS_BUILDING_FIELD_COLUMN_NET_WIDTH: "{sum}层柱网宽",
    WMS_BUILDING_FIELD_COLUMN_NET_HEIGHT: "{sum}层柱网深",
    WMS_BUILDING_FIELD_LONGITUDE: "经度",
    WMS_BUILDING_FIELD_LATITUDE: "纬度",
    WMS_BUILDING_FIELD_COOPERATION_TYPE: "合作类型",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_PURE_WAREHOUSE: "纯租仓",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_WAREHOUSE_MANAGER: "可提供租仓+仓储管理服务",
    WMS_BUILDING_FIELD_COOPERATION_TYPE_OUTSOURCE: "必须托管/外包",
    // 租户管理
    WMS_LESSEE__ROUTE_MANAGEMENT: "租户管理",
    WMS_LESSEE_COMPANY_ROUTE_LIST: "租户一览",
    WMS_LESSEE_COMPANY_BRAND: "所属品牌",
    WMS_LESSEE_COMPANY_NAME: "租户名称",
    WMS_LESSEE_COMPANY_CATEGORY: "租户分类",
    WMS_LESSEE_COMPANY_TYPE: "租户类型",
    WMS_LESSEE_COMPANY_TERMINAL_NAME: "终端用户名称",
    WMS_LESSEE_COMPANY_TERMINAL_TYPE: "终端用户商品类型",
    WMS_LESSEE_COMPANY_CREATE: "租户创建",
    WMS_LESSEE_COMPANY_UPDATE: "租户更新",
    WMS_LESSEE_COMPANY_DELETE: "租户删除",
    WMS_LESSEE_COMPANY_COMMERCE:"电商",
    WMS_LESSEE_COMPANY_PL:"3PL",
    WMS_LESSEE_COMPANY_MANUFACTURING:"生产制造",
    WMS_LESSEE_COMPANY_RETAIL:"零售",
    WMS_LESSEE_COMPANY_EXPRESS:"快递快运",
    WMS_LESSEE_COMPANY_HEAD_LESSEE: "二房东",
    WMS_LESSEE_COMPANY_COLD_CHAIN: "冷链",
    WMS_LESSEE_COMPANY_HIGH_FREQUENCY_BRAND:"高频品牌",
    WMS_LESSEE_COMPANY_LOW_FREQUENCY_TENANT:"低频租户",
    // 出租人管理
    WMS_LESSOR_COMPANY_ROUTE_MANAGEMENT: "出租方管理",
    WMS_LESSOR_COMPANY_ROUTE_LIST: "出租方一览",
    WMS_LESSOR_COMPANY_TITLE_CREATE: "出租方创建",
    WMS_LESSOR_COMPANY_TITLE_UPDATE: "出租方更新",
    WMS_LESSOR_COMPANY_TITLE_DELETE: "出租方删除",
    WMS_LESSOR_COMPANY_FIELD_BRAND_ID: "品牌",
    WMS_LESSOR_COMPANY_FIELD_NAME: "名称",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_NAME: "联系人",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_PHONE: "联系电话",
    WMS_LESSOR_COMPANY_FIELD_CONTACT: "联系人详情",
    WMS_LESSOR_COMPANY_FIELD_CONTACT_LIST: "联系人一览",

    // 品牌管理
    WMS_BRAND_ROUTE_LIST: "品牌方一览",
    WMS_BRAND_TITLE_CREATE: "品牌方创建",
    WMS_BRAND_TITLE_UPDATE: "品牌方更新",
    WMS_BRAND_TITLE_DELETE: "品牌方删除",
    WMS_BRAND_FIELD_NAME_ZH_1: "中文名称1",
    WMS_BRAND_FIELD_NAME_ZH_2: "中文名称2",
    WMS_BRAND_FIELD_NAME_EN_1: "英文名称1",
    WMS_BRAND_FIELD_NAME_EN_2: "英文名称2",

    WMS_LESSOR_MSG_DELETE_CONFIRM: "确认要删除出租方吗？",
    WMS_LESSOR_MSG_CREATE_SUCCESS: "出租方创建成功",
    WMS_LESSOR_MSG_UPDATE_SUCCESS: "出租方更新成功",
    WMS_LESSOR_DELETE_SUCCESS: "出租方删除成功",

    // 出租方联系人
    WMS_LESSOR_CONTACT_FIELD_NAME: "联系人",
    WMS_LESSOR_CONTACTS_TITLE_CREATE: "联系人创建",
    WMS_LESSOR_CONTACTS_TITLE_UPDATE: "联系人更新",
    WMS_LESSOR_CONTACTS_TITLE_DELETE: "联系人删除",
    WMS_LESSOR_CONTACT_FIELD_PHONE: "联系电话",
    WMS_LESSOR_CONTACT_FIELD_POSITION: "联系人职位",
    WMS_LESSOR_CONTACT_FIELD_MAIN_FLAG: "主联系人",
    WMS_LESSOR_CONTACT_TITLE_CREATE: "出租方联系人创建",
    WMS_LESSOR_CONTACT_TITLE_UPDATE: "出租方联系人更新",

    // 联系人一览
    WMS_CONTACT_FIELD_NAME: "联系人",
    WMS_CONTACTS_TITLE_CREATE: "联系人创建",
    WMS_CONTACTS_TITLE_UPDATE: "联系人更新",
    WMS_CONTACTS_TITLE_DELETE: "联系人删除",
    WMS_CONTACT_FIELD_PHONE: "联系电话",
    WMS_CONTACT_FIELD_POSITION: "联系人职位",
    WMS_CONTACT_FIELD_AREA: "负责区域",
    WMS_CONTACT_COMPANY_FIELD_BRAND_ID: "品牌",
    WMS_CONTACT_COMPANY_FIELD_LESSOR_ID: "出租方公司",
    WMS_CONTACT_COMPANY_FIELD_TENEMENT_ID: "租户公司",
    WMS_CONTACT_COMPANY_FIELD_ZONE_ID: "房源",
    WMS_CONTACT_FIELD_MAIN_FLAG: "主联系人",
    WMS_CONTACT_TITLE_CREATE: "租户联系人创建",
    WMS_CONTACT_TITLE_UPDATE: "租户联系人更新",

    // 方案组
    WMS_PROPOSAL_GROUP_TITLE_SELECT: "方案组选择",
    WMS_PROPOSAL_GROUP_TITLE_CREATE: "方案组新建",
    WMS_PROPOSAL_GROUP_FIELD_NAME: "方案组名称",
    WMS_PROPOSAL_GROUP_MSG_PROPOSAL_ZONE_NUMBER_UNIQUE: "该方案已添加。",

    // 报价方案
    WMS_PROPOSAL_ROUTE_MANAGEMENT: "方案管理",
    WMS_PROPOSAL_ROUTE_LIST: "方案一览",
    WMS_PROPOSAL_ROUTE_DETAIL: "方案详情",
    WMS_PROPOSAL_ROUTE_COMPARE: "方案比较",
    WMS_PROPOSAL_FIELD_GROUP_NAME: "方案组名",
    WMS_PROPOSAL_FIELD_NUMBER: "编号",
    WMS_PROPOSAL_FIELD_NUMBER_PREFIX: "方案",
    WMS_PROPOSAL_FIELD_ZONE_NUMBER: "项目编号",
    WMS_PROPOSAL_FIELD_ZONE_NAME: "项目名称",
    WMS_PROPOSAL_FIELD_ZONE_ADDRESS: "地址",
    WMS_PROPOSAL_FIELD_ZONE_PHOTOS: "项目照片",
    WMS_PROPOSAL_FIELD_NAME: "名称",
    WMS_PROPOSAL_FIELD_BUILDING_TYPE: "楼层",
    WMS_PROPOSAL_FIELD_BUILDING_AREA: "总面积",
    WMS_PROPOSAL_FIELD_VACANT_AREA: "可租面积",
    WMS_PROPOSAL_FIELD_VACANT_AREA_REMARKS: "备注说明",
    WMS_PROPOSAL_FIELD_QUOTATION: "单价",
    WMS_PROPOSAL_FIELD_QUOTATION_REMARKS: "单价备注",
    WMS_PROPOSAL_FIELD_PLATFORM: "有无月台",
    WMS_PROPOSAL_FIELD_ELEVATOR_TYPE: "电梯",
    WMS_PROPOSAL_FIELD_PLATFORM_HEIGHT: "月台高度",
    WMS_PROPOSAL_FIELD_PLATFORM_WIDTH: "月台宽度",
    WMS_PROPOSAL_FIELD_TURNOVER_AREA: "周转场地",
    WMS_PROPOSAL_FIELD_COLUMN_NET_WIDTH: "柱网宽",
    WMS_PROPOSAL_FIELD_COLUMN_NET_HEIGHT: "柱网深",
    WMS_PROPOSAL_FIELD_FIRE_FACILITIES: "消防设施",
    WMS_PROPOSAL_FIELD_FIRE_RATING: "消防等级",
    WMS_PROPOSAL_FIELD_FIRE_FACILITIES_RATING: "消防等级",
    WMS_PROPOSAL_FIELD_FLOOR_HEIGHT: "层高",
    WMS_PROPOSAL_FIELD_COLUMN_NET: "柱网",
    WMS_PROPOSAL_FIELD_FLOOR_LOAD: "承重",
    WMS_PROPOSAL_FIELD_UNLOADING_TYPE: "有无卸货场地",
    WMS_PROPOSAL_FIELD_RENTAL_DATA: "可租日期",
    WMS_PROPOSAL_FIELD_TAX_REQUIREMENTS: "落税要求",
    WMS_PROPOSAL_FIELD_TAX_RATE: "税点",
    WMS_PROPOSAL_FIELD_BILL_TYPE: "发票类型",
    WMS_PROPOSAL_FIELD_RENT_FREE_CONDITION: "年免",
    WMS_PROPOSAL_FIELD_RENT_FREE_PERIOD: "个月",
    WMS_PROPOSAL_FIELD_EFFECTIVE_PRICE: "有效价格",
    WMS_PROPOSAL_FIELD_PUBLISH_GROUP_NAME: "方案组名称",
    WMS_PROPOSAL_FIELD_PUBLISH_FLAG: "发布标识",
    WMS_PROPOSAL_FIELD_PUBLISH_TIME: "发布时间",
    WMS_PROPOSAL_TITLE_PREVIEW: "方案预览",
    // 跟进记录
    WMS_FOLLOWUP_TITLE_CREATE_FOLLOW: "创建跟进",
    WMS_FOLLOWUP_TITLE_MODIFY_FOLLOW: "更新跟进",
    WMS_FOLLOWUP_FIELD_FOLLOW_TIME: "跟进时间",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE: "跟进方式",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_PASSIVE: "数据变动",
    WMS_FOLLOWUP_FIELD_FOLLOW_TYPE_ACTIVE: "主动添加",
    WMS_FOLLOWUP_FIELD_FOLLOW_USER_NAME: "跟进者",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT: "跟进内容",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT_BUILDING_AREA: "建筑面积：从{source}平方米修改为{target}平方米。",
    WMS_FOLLOWUP_FIELD_FOLLOW_CONTENT_VACANT_AREA: "空置面积：从{source}平方米修改为{target}平方米。",
};
export default ja_JP;